export default __webpack_public_path__ + "scenes14564ea.png";